export default __webpack_public_path__ + "static/media/logoB.aacbf73c.png";